import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styles from "./contact.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default ({ data }) => (
  <StaticQuery
    query={graphql`
      query {
        road: file(relativePath: { eq: "road-2.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        mark: file(relativePath: { eq: "mark.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        data: site {
          siteMetadata {
            websiteConfig {
              contact {
                name
                address {
                  icon
                  content
                }
                phone {
                  icon
                  content
                }
                faxe {
                  icon
                  content
                }
                email {
                  icon
                  content
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <div className={`row mt-5 pb-4 ${styles.main}`} id="contact">
          <div className="col-lg-12 p-0">
            <h2>Contactez Nous</h2>
            <div className="sBar" />
            <span className="welcome">Publicités & Marketing</span>
          </div>
          <div className="col-lg-5 p-0">
            <Img
              className={styles.road}
              fluid={data.road.childImageSharp.fluid}
            />
          </div>
          <div className="col-lg-7" style={{ backgroundColor: "white" }}>
            <div className="info d-flex  flex-wrap">
              <div className="w-100 pl-2">
                <FontAwesomeIcon
                  className={styles.svg}
                  icon={
                    data.data.siteMetadata.websiteConfig.contact.address.icon
                  }
                  className={styles.svg}
                />
                {data.data.siteMetadata.websiteConfig.contact.address.content}
              </div>
              <div className="w-100 pl-2">
                <FontAwesomeIcon
                  className={styles.svg}
                  icon={data.data.siteMetadata.websiteConfig.contact.phone.icon}
                />
                {data.data.siteMetadata.websiteConfig.contact.phone.content}
              </div>
              <div className="w-100 pl-2">
                <FontAwesomeIcon
                  className={styles.svg}
                  icon={data.data.siteMetadata.websiteConfig.contact.faxe.icon}
                />
                {data.data.siteMetadata.websiteConfig.contact.faxe.content}
              </div>
              <div className="w-100 pl-2">
                <FontAwesomeIcon
                  className={styles.svg}
                  icon={data.data.siteMetadata.websiteConfig.contact.email.icon}
                />
                {data.data.siteMetadata.websiteConfig.contact.email.content}
              </div>
            </div>
            <form className="mt-2">
              <div className="d-flex  flex-wrap pt-3">
                <div className="formElement ">
                  <input type="email" placeholder="email" />
                </div>
                <div className="formElement ">
                  <input type="tel" placeholder="Téléphone" />
                </div>
              </div>
              <div className="d-flex ">
                <div className="formElement ">
                  <select name="object" className={styles.select}>
                    <option value="doleance">Doléance</option>
                    <option value="produit">Produit</option>
                    <option value="facturation">Facturation</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>
              </div>

              <div className="formElement d-flex ">
                <textarea
                  className={styles.textarea}
                  name="message"
                  id=""
                  cols="30"
                  rows="4"
                />
              </div>
              <div className="d-flex  pt-3">
                <button className={`btn-action ${styles.btn}`}>Envoyez</button>
              </div>
            </form>
          </div>
        </div>
      )
    }}
  />
)
